import {Button} from "primereact/button";
import React from "react";
import useApiEmpleados from "../../../api/catalogos/useApiEmpleados";
import alerts from "../../../shared/alerts";

const RegenerarQr = ({empleadoId, onQrRegenerado})=>{
    const api = useApiEmpleados()


    const regenerarQr = async () => {
        //preguntar si desea regenerar el qr
        const confirmar = await alerts.preguntarSiNoAdvertencia("Va a generar otro QR para el empleado, deberá reimprimir su gafete: ¿Desea Continuar?");
        if (!confirmar) {
            return;
        }
        const nuevaVersion = await api.regenerarQr(empleadoId);

        onQrRegenerado(nuevaVersion)
    }

    return (
        <Button label={'Regenerar Qr'} type="button" className="p-button-warning" onClick={regenerarQr}/>
    )
}
export default RegenerarQr;